'use client';
import styles from './list.module.css';
import Card from '@/components/trials/card/card';
import Sort from '@/components/trials/sort/sort';
import { useTrials } from '@/context/trials-context';
import Loading from '@/components/loading/loading';
import NoData from './no-data';
import { useProperties } from '@/context/properties-context';
import ErrorFetching from './error';

export default function List() {
	const { trials, trialsCount, isLoading, error, hasSponsor } = useTrials();

	const {
		properties: { page },
	} = useProperties();

	if (isLoading) return <Loading text='Almost ready...' />;

	return (
		<div className={styles.list}>
			<Sort />
			{error ? (
				<ErrorFetching />
			) : (
				<div className={styles.cards}>
					{trials &&
						trials.length > 0 &&
						trials?.map((trial, i) => (
							<Card
								key={trial.objectID}
								trial={trial}
								sponsored={page === 1 && i === 0 && hasSponsor}
							/>
						))}

					{trialsCount === 0 && <NoData />}
				</div>
			)}
		</div>
	);
}
